
var Globalize = require('globalize/dist/globalize-runtime');
require('globalize/dist/globalize-runtime/number');
require('globalize/dist/globalize-runtime/plural');
require('globalize/dist/globalize-runtime/message');
require('globalize/dist/globalize-runtime/date');
var validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
var validateParameterPresence = Globalize._validateParameterPresence;
var numberRound = Globalize._numberRound;
var numberFormat = Globalize._numberFormat;
var numberFormatterFn = Globalize._numberFormatterFn;
var validateParameterTypeString = Globalize._validateParameterTypeString;
var numberParse = Globalize._numberParse;
var numberParserFn = Globalize._numberParserFn;
var pluralGeneratorFn = Globalize._pluralGeneratorFn;
var validateParameterTypeMessageVariables = Globalize._validateParameterTypeMessageVariables;
var messageFormat = Globalize._messageFormat;
var messageFormatterFn = Globalize._messageFormatterFn;
var validateParameterTypeDate = Globalize._validateParameterTypeDate;
var dateToPartsFormat = Globalize._dateToPartsFormat;
var dateToPartsFormatterFn = Globalize._dateToPartsFormatterFn;
var dateFormat = Globalize._dateFormat;
var dateFormatterFn = Globalize._dateFormatterFn;
var dateTokenizer = Globalize._dateTokenizer;
var dateParse = Globalize._dateParse;
var dateParserFn = Globalize._dateParserFn;

Globalize.b1955428342 = numberFormatterFn(["",,2,0,0,,,,,,"","00","-00","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a2039621642 = numberFormatterFn(["",,4,0,0,,,,,,"","0000","-0000","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b478730998 = numberFormatterFn(["",,1,0,0,,,,,,"","0","-0","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a556405393 = numberParserFn([{",":".",".":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},,{"infinity":/^∞/,"nan":/^NaN/,"negativePrefix":/^-/,"negativeSuffix":/^/,"number":/^\d+/,"prefix":/^/,"suffix":/^/}]);
Globalize.a1568135870 = pluralGeneratorFn(function(n
) {
  var s = String(n).split('.'), v0 = !s[1];
  return (n == 1 && v0) ? 'one' : 'other';
});
Globalize.b2080995020 = messageFormatterFn((function(  ) {
  return function(d) { return "Accesso"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1000841834 = messageFormatterFn((function(  ) {
  return function(d) { return "Accedi"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a92902293 = messageFormatterFn((function(  ) {
  return function(d) { return "Indirizzo e-mail"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b181598812 = messageFormatterFn((function(  ) {
  return function(d) { return "Password"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1538817347 = messageFormatterFn((function(  ) {
  return function(d) { return "È un dispositivo pubblico o condiviso"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1788891260 = messageFormatterFn((function(  ) {
  return function(d) { return "Non è il tuo dispositivo? Selezionando questa casella manterrai l’accesso al tuo account per una durata ridotta, fino al momento della disconnessione automatica."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1003725847 = messageFormatterFn((function(  ) {
  return function(d) { return "Mantieni l’accesso"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1218561785 = messageFormatterFn((function(  ) {
  return function(d) { return "Selezionando questa casella manterrai l’accesso al tuo account su questo dispositivo fino al momento della disconnessione. Non selezionare questa opzione su dispositivi condivisi."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b2054985473 = messageFormatterFn((function(  ) {
  return function(d) { return "Hai dimenticato la password?"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1618455472 = messageFormatterFn((function(  ) {
  return function(d) { return "Continua"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b159552381 = messageFormatterFn((function(  ) {
  return function(d) { return "Annulla"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a2011999014 = messageFormatterFn((function(  ) {
  return function(d) { return "Torna indietro"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a395872808 = messageFormatterFn((function(  ) {
  return function(d) { return "Aggiorna"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1703970669 = messageFormatterFn((function(  ) {
  return function(d) { return "Accedendo, accetto <a href=" + d["1"] + " " + d["3"] + ">termini e condizioni</a> e <a href=" + d["2"] + " " + d["4"] + ">informativa sulla privacy</a> di " + d["0"] + "."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1650098709 = messageFormatterFn((function(  ) {
  return function(d) { return "Accedendo, accetto <a href=" + d["1"] + " " + d["5"] + ">termini e condizioni</a> e <a href=" + d["2"] + " " + d["6"] + ">informativa sulla privacy</a> di " + d["0"] + ", e <a href=" + d["3"] + " " + d["7"] + ">termini e condizioni di " + d["4"] + "</a>."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1484178525 = messageFormatterFn((function(  ) {
  return function(d) { return "Con il mio accesso autorizzo anche l’iscrizione a " + d["4"] + ". Accetto <a href=" + d["1"] + " " + d["5"] + ">termini e condizioni</a> e <a href=" + d["2"] + " " + d["6"] + ">informativa sulla privacy</a> di " + d["0"] + ", e <a href=" + d["3"] + " " + d["7"] + ">termini e condizioni di " + d["4"] + "</a>."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a68849144 = messageFormatterFn((function(  ) {
  return function(d) { return "Il tuo account è stato messo in pausa durante un controllo di sicurezza di routine. I tuoi dati sono al sicuro, ma devi reimpostare la password. Fallo tramite il link \"Hai dimenticato la password?\" qui sotto e accedi."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1653558158 = messageFormatterFn((function(  ) {
  return function(d) { return "E-mail e password non corrispondono, riprova."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a716375849 = messageFormatterFn((function(  ) {
  return function(d) { return "Siamo spiacenti, si è verificato un problema."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1202870545 = messageFormatterFn((function(  ) {
  return function(d) { return "Siamo spiacenti, si è verificato un problema. Riprova tra qualche istante."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b406005491 = messageFormatterFn((function(  ) {
  return function(d) { return "Inserisci il tuo indirizzo e-mail"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1731274910 = messageFormatterFn((function(  ) {
  return function(d) { return "Inserisci un indirizzo e-mail valido"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1377776612 = messageFormatterFn((function(  ) {
  return function(d) { return "Inserisci la tua password"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b654857786 = messageFormatterFn((function(  ) {
  return function(d) { return "Stiamo controllando le tue credenziali di accesso"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b741560129 = messageFormatterFn((function(  ) {
  return function(d) { return "Nascondi password"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b427217990 = messageFormatterFn((function(  ) {
  return function(d) { return "Mostra password"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a718365764 = messageFormatterFn((function(  ) {
  return function(d) { return "Non hai un account? <span><a id=\"createAcctRedirectLink\" href=" + d["0"] + ">Crealo subito</a></span>"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b328313975 = messageFormatterFn((function(  ) {
  return function(d) { return "Accedi"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1975205952 = messageFormatterFn((function(  ) {
  return function(d) { return "Non è più possibile accedere tramite " + d["0"]; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1554332892 = messageFormatterFn((function(  ) {
  return function(d) { return "Puoi accedere al tuo account " + d["0"] + " utilizzando lo stesso indirizzo e-mail e reimpostando la password. Questo non avrà ripercussioni sul tuo account " + d["1"] + "."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a265887058 = messageFormatterFn((function(  ) {
  return function(d) { return "Reimposta la tua password usando il pulsante in basso. La prossima volta, potrai usare il tuo indirizzo e-mail e la nuova password per accedere direttamente a " + d["0"] + "."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a280208715 = messageFormatterFn((function(  ) {
  return function(d) { return "Accesso SSO"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a158659411 = messageFormatterFn((function(  ) {
  return function(d) { return "Accedi usando l’opzione Single Sign-On"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b426031359 = messageFormatterFn((function(  ) {
  return function(d) { return "O usa il tuo account " + d["0"]; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1122076980 = messageFormatterFn((function(  ) {
  return function(d) { return "Accumula punti per viaggiare gratis, risparmia con le tariffe per soli iscritti e accedi facilmente ai tuoi itinerari."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b2041025970 = messageFormatterFn((function(  ) {
  return function(d) { return "Accumula " + d["0"] + " punti Expedia Rewards con questo viaggio."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1691739307 = messageFormatterFn((function(  ) {
  return function(d) { return "Accedi a " + d["0"]; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1859466839 = messageFormatterFn((function(  ) {
  return function(d) { return "Password dimenticata"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1605539118 = messageFormatterFn((function(  ) {
  return function(d) { return "Reimposta la tua password"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1975772600 = messageFormatterFn((function(  ) {
  return function(d) { return "Inserisci il tuo indirizzo e-mail e ti invieremo un link per reimpostare la password."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a2073216692 = messageFormatterFn((function(  ) {
  return function(d) { return "Invia il link"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a250871727 = messageFormatterFn((function(  ) {
  return function(d) { return "Controlla la tua posta in arrivo"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1551229865 = messageFormatterFn((function(  ) {
  return function(d) { return "Abbiamo inviato il link per reimpostare la password all’indirizzo e-mail " + d["0"] + "."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1551228904 = messageFormatterFn((function(  ) {
  return function(d) { return "Potrebbe impiegare qualche minuto per arrivare. Se non ricevi nulla entro 10 minuti, controlla nella casella della posta indesiderata."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a765961982 = messageFormatterFn((function(  ) {
  return function(d) { return "Invia di nuovo il link"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a682986490 = messageFormatterFn((function(  ) {
  return function(d) { return "Ti abbiamo inviato un nuovo link."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1635789331 = messageFormatterFn((function(  ) {
  return function(d) { return "Stiamo verificando il tuo account"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a863374931 = messageFormatterFn((function(  ) {
  return function(d) { return "Imposta password"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1262610364 = messageFormatterFn((function(  ) {
  return function(d) { return "Ci fa piacere rivederti"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1013940962 = messageFormatterFn((function(  ) {
  return function(d) { return "Crea una nuova password per continuare"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1590779731 = messageFormatterFn((function(  ) {
  return function(d) { return "Operazione riuscita."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a344876362 = messageFormatterFn((function(  ) {
  return function(d) { return "Ora usa la nuova password per proseguire."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a2119376571 = messageFormatterFn((function(  ) {
  return function(d) { return "Reimposta la password"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a482608866 = messageFormatterFn((function(  ) {
  return function(d) { return "Ci dispiace, la richiesta è scaduta. Se hai ancora bisogno di cambiare la tua password, clicca qui sotto e riceverai una nuova e-mail per reimpostarla."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1677353870 = messageFormatterFn((function(  ) {
  return function(d) { return "Invia di nuovo il link"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a525375773 = messageFormatterFn((function(  ) {
  return function(d) { return "Stiamo salvando la tua password"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a514628239 = messageFormatterFn((function(  ) {
  return function(d) { return "Crea account"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1270293507 = messageFormatterFn((function(  ) {
  return function(d) { return "Crea un account"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1578357682 = messageFormatterFn((function(  ) {
  return function(d) { return "Indirizzo e-mail"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1008647366 = messageFormatterFn((function(  ) {
  return function(d) { return "Inserisci il tuo indirizzo e-mail"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1556915305 = messageFormatterFn((function(  ) {
  return function(d) { return "Inserisci un indirizzo e-mail valido"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a375572077 = messageFormatterFn((function(  ) {
  return function(d) { return "Nome"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a996694757 = messageFormatterFn((function(  ) {
  return function(d) { return "Inserisci il tuo nome"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a2017966033 = messageFormatterFn((function(  ) {
  return function(d) { return "Cognome"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1702775719 = messageFormatterFn((function(  ) {
  return function(d) { return "Inserisci il tuo cognome"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b719255214 = messageFormatterFn((function(  ) {
  return function(d) { return "Inserisci il nome utilizzando solo lettere"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1426618805 = messageFormatterFn((function(  ) {
  return function(d) { return "Password"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b852393261 = messageFormatterFn((function(  ) {
  return function(d) { return "Inserisci la tua password"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1708074594 = messageFormatterFn((function(  ) {
  return function(d) { return "Inserisci una password valida"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1446079006 = messageFormatterFn((function(  ) {
  return function(d) { return "Deve contenere dai 9 ai 64 caratteri"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1446079967 = messageFormatterFn((function(  ) {
  return function(d) { return "Deve includere lettere e numeri"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1446080928 = messageFormatterFn((function(  ) {
  return function(d) { return "Almeno 1 carattere speciale, come ~ " + "#" + " @ $ % & ! * _ ? ^ -"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1446081889 = messageFormatterFn((function(  ) {
  return function(d) { return "La password non può contenere spazi"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a197947032 = messageFormatterFn((function(  ) {
  return function(d) { return "La tua password deve contenere da 8 a 64 caratteri"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b2092836667 = messageFormatterFn((function(  ) {
  return function(d) { return "Non puoi utilizzare il tuo indirizzo e-mail come password."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a686987586 = messageFormatterFn((function(  ) {
  return function(d) { return "La password non può contenere spazi."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b668894470 = messageFormatterFn((function(  ) {
  return function(d) { return "Creando un account, accetto <a href=" + d["1"] + " " + d["3"] + ">termini e condizioni</a> e <a href=" + d["2"] + " " + d["4"] + ">informativa sulla privacy</a> di " + d["0"] + "."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b2024506456 = messageFormatterFn((function(  ) {
  return function(d) { return "Creando un account, accetto <a href=" + d["1"] + " " + d["5"] + ">termini e condizioni</a> e <a href=" + d["2"] + " " + d["6"] + ">informativa sulla privacy</a> di " + d["0"] + ", e <a href=" + d["3"] + " " + d["7"] + ">termini e condizioni di " + d["4"] + "</a>."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b948748087 = messageFormatterFn((function(  ) {
  return function(d) { return "Desidero ricevere e-mail da " + d["0"] + " con offerte speciali, promozioni e altre informazioni."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b680284090 = messageFormatterFn((function(  ) {
  return function(d) { return "Desidero ricevere e-mail da " + d["0"] + " con offerte speciali, promozioni e altre informazioni. Puoi annullare l’iscrizione alle e-mail promozionali in qualsiasi momento."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a2093287116 = messageFormatterFn((function(  ) {
  return function(d) { return "Desidero ricevere e-mail da " + d["0"] + " con idee per le vacanze, offerte speciali e altre informazioni."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1028458275 = messageFormatterFn((function(  ) {
  return function(d) { return "Desidero ricevere e-mail da " + d["0"] + " con idee per le vacanze, offerte speciali e altre informazioni. Puoi annullare l’iscrizione alle e-mail promozionali in qualsiasi momento."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a373435479 = messageFormatterFn((function(  ) {
  return function(d) { return "Continua"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b701667812 = messageFormatterFn((function(  ) {
  return function(d) { return "Hai già un account? <span><a id=\"signinRedirectLink\" href=" + d["0"] + ">Accedi</a></span>"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a354700641 = messageFormatterFn((function(  ) {
  return function(d) { return "Ciao " + d["0"] + "!"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1355785403 = messageFormatterFn((function(  ) {
  return function(d) { return "Con il tuo nuovo account " + d["0"] + ", viaggiare non è mai stato così semplice."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1456509874 = messageFormatterFn((function(  ) {
  return function(d) { return "Continua"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b408979261 = messageFormatterFn((function(  ) {
  return function(d) { return "Inserisci una password più sicura per continuare"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1855860600 = messageFormatterFn((function(  ) {
  return function(d) { return "Deve contenere almeno 8 caratteri."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b599662676 = messageFormatterFn((function(  ) {
  return function(d) { return "Sicurezza della password"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1684717846 = messageFormatterFn((function(  ) {
  return function(d) { return "Non sicura"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1944776779 = messageFormatterFn((function(  ) {
  return function(d) { return "Sicura"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1007869557 = messageFormatterFn((function(  ) {
  return function(d) { return "Molto sicura"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a848966202 = messageFormatterFn((function(  ) {
  return function(d) { return "Evita sostituzioni di lettere abituali, come \"@\" al posto di \"a\"."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1191260126 = messageFormatterFn((function(  ) {
  return function(d) { return "Evita di scrivere al contrario parole di uso comune."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b116169322 = messageFormatterFn((function(  ) {
  return function(d) { return "Usa alcune lettere maiuscole, ma non tutte."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b287795273 = messageFormatterFn((function(  ) {
  return function(d) { return "Usa la maiuscola in altre lettere, oltre alla prima."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1312076869 = messageFormatterFn((function(  ) {
  return function(d) { return "Evita date e anni associati a te."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b2134644037 = messageFormatterFn((function(  ) {
  return function(d) { return "Evita gli anni recenti."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1427825322 = messageFormatterFn((function(  ) {
  return function(d) { return "Evita gli anni associati a te."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1951592617 = messageFormatterFn((function(  ) {
  return function(d) { return "Evita le sequenze abituali di caratteri."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b210710159 = messageFormatterFn((function(  ) {
  return function(d) { return "Evita di ripetere parole e caratteri."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1888456683 = messageFormatterFn((function(  ) {
  return function(d) { return "Evita di utilizzare sequenze di caratteri della tastiera, come una serie di tasti in fila."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1501024506 = messageFormatterFn((function(  ) {
  return function(d) { return "Aggiungi più parole di uso meno comune."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b522000922 = messageFormatterFn((function(  ) {
  return function(d) { return "Usa più parole, ma evita le frasi abituali."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1191115063 = messageFormatterFn((function(  ) {
  return function(d) { return "Puoi creare password sicure senza utilizzare simboli, numeri o lettere maiuscole."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1819599984 = messageFormatterFn((function(  ) {
  return function(d) { return "Questo indirizzo e-mail risulta già associato a un account su " + d["0"]; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1555165762 = messageFormatterFn((function(  ) {
  return function(d) { return "Ti abbiamo inviato un’e-mail con il link per completare la creazione del tuo account."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1363968275 = messageFormatterFn((function(  ) {
  return function(d) { return "Stiamo creando il tuo account"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b906378791 = messageFormatterFn((function(  ) {
  return function(d) { return "Il nome deve essere formato da almeno due lettere"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1336461813 = messageFormatterFn((function(  ) {
  return function(d) { return "Il cognome deve essere formato da almeno due lettere"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a341671047 = messageFormatterFn((function(  ) {
  return function(d) { return "La lunghezza massima del nome è di 100 caratteri"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1710455645 = messageFormatterFn((function(  ) {
  return function(d) { return "La lunghezza massima del cognome è di 100 caratteri"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1944896062 = messageFormatterFn((function(  ) {
  return function(d) { return "Il nome non può contenere caratteri speciali"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1646309086 = messageFormatterFn((function(  ) {
  return function(d) { return "Il cognome non può contenere caratteri speciali"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1616097120 = messageFormatterFn((function(  ) {
  return function(d) { return "Accetto quanto segue"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a147718060 = messageFormatterFn((function(  ) {
  return function(d) { return "Confermo di essere maggiorenne e di aver letto e accettato i <a href=" + d["0"] + " " + d["1"] + ">termini di utilizzo</a> e i <a href=" + d["2"] + " " + d["3"] + ">termini e condizioni di " + d["4"] + "</a> (obbligatorio)."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b158302954 = messageFormatterFn((function(  ) {
  return function(d) { return "Acconsento alla raccolta e all’utilizzo dei miei dati personali come indicato nell’<a href=" + d["0"] + " " + d["1"] + ">informativa sulla privacy</a> (obbligatorio)"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b28577033 = messageFormatterFn((function(  ) {
  return function(d) { return "Autorizzo la condivisione dei miei dati personali con terzi, sia in Corea sia in un altro paese, come descritto nell’<a href=" + d["0"] + " " + d["1"] + ">informativa sulla privacy</a> (obbligatorio)"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1263087284 = messageFormatterFn((function(  ) {
  return function(d) { return "Accetta i termini e condizioni per continuare"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1672576976 = messageFormatterFn((function(  ) {
  return function(d) { return "Accetta i termini per continuare"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a780134444 = messageFormatterFn((function(  ) {
  return function(d) { return "Seleziona la casella per continuare"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1156616485 = messageFormatterFn((function(  ) {
  return function(d) { return "O crea un account con " + d["0"]; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1396870791 = messageFormatterFn((function(  ) {
  return function(d) { return "Evita di usare spazi, il tuo nome o indirizzo e-mail e password già utilizzate."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b818687741 = messageFormatterFn((function(  ) {
  return function(d) { return "Si è verificato un problema. Riprova tra qualche istante."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b2136013911 = messageFormatterFn((function(  ) {
  return function(d) { return "Verifica il tuo numero di cellulare"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b97495974 = messageFormatterFn((function(  ) {
  return function(d) { return "Ti invieremo un codice di verifica utilizzabile una sola volta sul cellulare, per confermare che il tuo account è sicuro."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a840416717 = messageFormatterFn((function(  ) {
  return function(d) { return "Invia"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b569564134 = messageFormatterFn((function(  ) {
  return function(d) { return "©" + d["1"] + " " + d["0"] + ". Tutti i diritti riservati."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b2048946328 = messageFormatterFn((function(  ) {
  return function(d) { return "Termini e condizioni"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1275413591 = messageFormatterFn((function(  ) {
  return function(d) { return "Informativa sulla Privacy"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1387156544 = messageFormatterFn((function(  ) {
  return function(d) { return "Invia SMS"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1965612117 = messageFormatterFn((function(  ) {
  return function(d) { return "Inserisci il codice di verifica"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a128170503 = messageFormatterFn((function(  ) {
  return function(d) { return "Codice di verifica"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a745384954 = messageFormatterFn((function(  ) {
  return function(d) { return "Invia di nuovo il codice"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b570921007 = messageFormatterFn((function(  ) {
  return function(d) { return "Cambia il numero di cellulare"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b502532093 = messageFormatterFn((function(  ) {
  return function(d) { return "Ti abbiamo inviato di nuovo il codice di verifica."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a538427172 = messageFormatterFn((function(  ) {
  return function(d) { return "Inserisci il codice di verifica di 6 cifre che abbiamo appena inviato al numero " + d["0"]; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1117609047 = messageFormatterFn((function(  ) {
  return function(d) { return "Stiamo controllando il codice di verifica"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1668416130 = messageFormatterFn((function(  ) {
  return function(d) { return "Il codice non è corretto. Invia di nuovo il codice e riprova."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b332019576 = messageFormatterFn((function(  ) {
  return function(d) { return "o continua con"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1088231784 = messageFormatterFn((function(  ) {
  return function(d) { return "Iscriviti gratuitamente e risparmia in media un " + d["0"] + "% su migliaia di hotel."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1480232486 = messageFormatterFn((function(  ) {
  return function(d) { return "o"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1467903580 = messageFormatterFn((function(  ) {
  return function(d) { return "Oppure accedi con"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1467544166 = messageFormatterFn((function(  ) {
  return function(d) { return "Oppure iscriviti con"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b18465040 = messageFormatterFn((function(  ) {
  return function(d) { return "Iscriviti con Google"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b757158193 = messageFormatterFn((function(  ) {
  return function(d) { return "Accesso non riuscito. Riprova o crea un account su questo sito per continuare."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1497822537 = messageFormatterFn((function(  ) {
  return function(d) { return "L’accesso tramite numero di telefono non è consentito. Assicurati che l’indirizzo e-mail associato al tuo account social media sia condivisibile."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b2138616767 = messageFormatterFn((function(  ) {
  return function(d) { return "Iscriviti gratuitamente e risparmia un " + d["0"] + "% o anche di più su migliaia di hotel."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1942756134 = messageFormatterFn((function(  ) {
  return function(d) { return "Accedi con Google"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a2133037733 = messageFormatterFn((function(  ) {
  return function(d) { return "Accedi con NAVER"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b42312507 = messageFormatterFn((function(  ) {
  return function(d) { return "Hai superato il numero massimo dei tentativi di accesso. Riprova più tardi."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a514496920 = messageFormatterFn((function(  ) {
  return function(d) { return "Accedi con i tuoi dati biometrici"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b281926776 = messageFormatterFn((function(  ) {
  return function(d) { return "Usa i tuoi dati biometrici per accedere al tuo account, così non dovrai inserire la password."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1023483637 = messageFormatterFn((function(  ) {
  return function(d) { return "Scopri come fare"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1506697189 = messageFormatterFn((function(  ) {
  return function(d) { return "Ricordamelo più tardi"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1050802319 = messageFormatterFn((function(  ) {
  return function(d) { return "Fatto!"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1904626933 = messageFormatterFn((function(  ) {
  return function(d) { return "Hai attivato l’accesso con i dati biometrici."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a122095603 = messageFormatterFn((function(  ) {
  return function(d) { return "Accedi con i dati biometrici"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b288342664 = messageFormatterFn((function(  ) {
  return function(d) { return "Usa la password"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b802013347 = messageFormatterFn((function(  ) {
  return function(d) { return "Usa i dati biometrici"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b463929654 = messageFormatterFn((function(  ) {
  return function(d) { return "Aggiorna la tua password per continuare"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1690675214 = messageFormatterFn((function(  ) {
  return function(d) { return "Devi reimpostare la password per accedere al tuo account."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1046103640 = messageFormatterFn((function(  ) {
  return function(d) { return "Reimposta la password"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1674051496 = messageFormatterFn((function(  ) {
  return function(d) { return "Vantaggi per gli iscritti"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1877467442 = messageFormatterFn((function(  ) {
  return function(d) { return "Per farti iniziare al meglio la tua avventura, ti regaliamo $" + d["0"] + " in punti!"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1943682014 = messageFormatterFn((function(  ) {
  return function(d) { return "Puoi visualizzarli subito sul tuo account e usarli per la tua prima prenotazione. Ti basta cercare l’opzione per applicare i punti in fase di pagamento."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1974671952 = messageFormatterFn((function(  ) {
  return function(d) { return "Grazie per aver creato il tuo account Expedia."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1508522208 = messageFormatterFn((function(  ) {
  return function(d) { return "Inizia subito a risparmiare con le tariffe per soli iscritti e guadagna punti ogni volta che prenoti."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1883387435 = messageFormatterFn((function(  ) {
  return function(d) { return "Accedi o crea un account"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b288856859 = messageFormatterFn((function(  ) {
  return function(d) { return "Iscriviti gratuitamente e risparmia in media un " + d["0"] + "% su migliaia di hotel."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b120123715 = messageFormatterFn((function(  ) {
  return function(d) { return "Continuando, confermi di aver letto e accettato i nostri <a href=" + d["1"] + " " + d["3"] + ">Termini e condizioni</a> e l’<a href=" + d["2"] + " " + d["4"] + ">Informativa sulla privacy</a>."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1534483653 = messageFormatterFn((function(  ) {
  return function(d) { return "Continuando, confermi di aver letto e accettato i nostri <a href=" + d["1"] + " " + d["5"] + ">Termini e condizioni</a>, l’<a href=" + d["2"] + " " + d["6"] + ">Informativa sulla privacy</a> e i <a href=" + d["3"] + " " + d["7"] + ">Termini e condizioni di " + d["4"] + "</a>."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1734353440 = messageFormatterFn((function(  ) {
  return function(d) { return "Continuando, confermi di aver letto e accettato i nostri <a href=" + d["1"] + " " + d["4"] + ">Termini e condizioni</a>, l’<a href=" + d["2"] + " " + d["5"] + ">Informativa sulla privacy</a> e i <a href=" + d["3"] + " " + d["6"] + ">Termini e condizioni del programma fedeltà One Key</a>."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1311785532 = messageFormatterFn((function(  ) {
  return function(d) { return "Indirizzo e-mail"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a900849406 = messageFormatterFn((function(  ) {
  return function(d) { return "Inserisci un indirizzo valido"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1795412481 = messageFormatterFn((function(  ) {
  return function(d) { return "Google"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1351938062 = messageFormatterFn((function(  ) {
  return function(d) { return "Facebook"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1635182040 = messageFormatterFn((function(  ) {
  return function(d) { return "Apple"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a743504511 = messageFormatterFn((function(  ) {
  return function(d) { return "Questa opzione riguarda solo i dispositivi personali. Non spuntare questa casella su un dispositivo condiviso per proteggere la sicurezza del tuo account."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1119599758 = messageFormatterFn((function(  ) {
  return function(d) { return "Hai raggiunto il limite dei tentativi di accesso. Aspetta " + d["0"] + " minuti prima di riprovare."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a857494678 = messageFormatterFn((function(  ) {
  return function(d) { return "Hai raggiunto il limite dei tentativi di accesso. Aspetta " + d["0"] + " minuto prima di riprovare."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a862390012 = messageFormatterFn((function(  ) {
  return function(d) { return "Hai raggiunto il limite dei tentativi di accesso. Aspetta " + d["0"] + " minuti prima di riprovare."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a848932168 = messageFormatterFn((function(  ) {
  return function(d) { return "Hai raggiunto il limite dei tentativi di accesso. Aspetta " + d["0"] + " minuti prima di riprovare."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a743617157 = messageFormatterFn((function(  ) {
  return function(d) { return "Hai raggiunto il limite dei tentativi di accesso. Aspetta " + d["0"] + " minuti prima di riprovare."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b404772480 = messageFormatterFn((function(  ) {
  return function(d) { return "Hai raggiunto il limite dei tentativi di accesso. Aspetta " + d["0"] + " minuti prima di riprovare."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1713834863 = messageFormatterFn((function(  ) {
  return function(d) { return "Usa un unico account per ottenere vantaggi fedeltà quando prenoti su Expedia, Hotels.com e Vrbo."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1270066153 = messageFormatterFn((function(  ) {
  return function(d) { return "Usa un unico account per prenotare su Expedia, Hotels.com e Vrbo."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a451895920 = messageFormatterFn((function(  ) {
  return function(d) { return "Cerca e salva strutture, organizza tutto insieme ai tuoi compagni di viaggio e accedi ai dettagli della prenotazione."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1057226129 = messageFormatterFn((function(  ) {
  return function(d) { return "Il tuo account è stato messo in pausa durante un controllo di sicurezza di routine. I tuoi dati sono al sicuro, ma devi reimpostare la password."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1426865697 = messageFormatterFn((function(  ) {
  return function(d) { return "Accedi al tuo account e prenota per guadagnare OneKeyCash"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b112461229 = messageFormatterFn((function(  ) {
  return function(d) { return "Confermiamo la tua identità"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b2004517977 = messageFormatterFn((function(  ) {
  return function(d) { return "Inserisci il codice di sicurezza che ti abbiamo inviato tramite e-mail. Se non è nella posta in arrivo, controlla la cartella della posta indesiderata."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a2023119973 = messageFormatterFn((function(  ) {
  return function(d) { return "Conferma il tuo indirizzo e-mail"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a2039482453 = messageFormatterFn((function(  ) {
  return function(d) { return "Per continuare, inserisci il codice di sicurezza che abbiamo inviato a " + d["0"] + ". Se non è nella posta in arrivo, controlla la cartella della posta indesiderata."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1578469009 = messageFormatterFn((function(  ) {
  return function(d) { return "Codice a 6 cifre"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1613476241 = messageFormatterFn((function(  ) {
  return function(d) { return "Invia di nuovo il codice"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b773561560 = messageFormatterFn((function(  ) {
  return function(d) { return "(0:" + d["0"] + ")"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b417301072 = messageFormatterFn((function(  ) {
  return function(d) { return "Invia di nuovo il codice tra " + d["0"] + " sec"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1897389568 = messageFormatterFn((function(  ) {
  return function(d) { return "Non hai ricevuto l’e-mail?"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1573352798 = messageFormatterFn((function(  ) {
  return function(d) { return "Puoi richiedere un altro codice tra " + d["0"] + " sec"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b789227381 = messageFormatterFn((function(  ) {
  return function(d) { return "Richiedi un altro codice di sicurezza"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a235643733 = messageFormatterFn((function(  ) {
  return function(d) { return "Ti abbiamo inviato un codice a 6 cifre via e-mail."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1705271648 = messageFormatterFn((function(  ) {
  return function(d) { return "Inserisci la password"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1505780065 = messageFormatterFn((function(  ) {
  return function(d) { return "Codice non valido, riprova"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a397281423 = messageFormatterFn((function(  ) {
  return function(d) { return "Codice scaduto, invia di nuovo e riprova"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1514318852 = messageFormatterFn((function(  ) {
  return function(d) { return "Se non è nella posta in arrivo, controlla la cartella della posta indesiderata."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a2098857323 = messageFormatterFn((function(  ) {
  return function(d) { return "Abbiamo fatto alcune modifiche e dobbiamo confermare il tuo indirizzo e-mail. Inserisci il codice di sicurezza che ti abbiamo inviato."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b513962572 = messageFormatterFn((function(  ) {
  return function(d) { return "Si è verificato un problema, riprova."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a310775421 = messageFormatterFn((function(  ) {
  return function(d) { return "Per aggiornare il tuo metodo di accesso, inserisci il codice di sicurezza che ti abbiamo inviato tramite e-mail."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b751375127 = messageFormatterFn((function(  ) {
  return function(d) { return "Inserisci la password"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b534357470 = messageFormatterFn((function(  ) {
  return function(d) { return "Invia un codice di sicurezza via e-mail"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1979394050 = messageFormatterFn((function(  ) {
  return function(d) { return "E-mail e password non corrispondono"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1338450631 = messageFormatterFn((function(  ) {
  return function(d) { return "Crea una password"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b311587087 = messageFormatterFn((function(  ) {
  return function(d) { return "Crea una password"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1481849417 = messageFormatterFn((function(  ) {
  return function(d) { return "Puoi usare lo stesso indirizzo e-mail e la stessa password per accedere a Expedia, Hotels.com e Vrbo."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b2009435593 = messageFormatterFn((function(  ) {
  return function(d) { return "Crea password"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1915620026 = messageFormatterFn((function(  ) {
  return function(d) { return "Imposta una password da usare in aggiunta agli altri metodi di accesso sicuro."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a968371579 = messageFormatterFn((function(  ) {
  return function(d) { return "Imposta una nuova password"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a524729509 = messageFormatterFn((function(  ) {
  return function(d) { return "Imposta una nuova password"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1084276757 = messageFormatterFn((function(  ) {
  return function(d) { return "Ora puoi usare un unico account per accedere a Expedia, Hotels.com e Vrbo. Crea una nuova password sicura per il tuo account unico."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b576747285 = messageFormatterFn((function(  ) {
  return function(d) { return "Crea password"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1939676701 = messageFormatterFn((function(  ) {
  return function(d) { return "Modifica password"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a885187763 = messageFormatterFn((function(  ) {
  return function(d) { return "Imposta una password univoca e sicura."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b287131763 = messageFormatterFn((function(  ) {
  return function(d) { return "Aggiorna password"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a356014970 = messageFormatterFn((function(  ) {
  return function(d) { return "La password non è stata modificata, riprova."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1147302888 = messageFormatterFn((function(  ) {
  return function(d) { return "Password dimenticata"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1697130558 = messageFormatterFn((function(  ) {
  return function(d) { return "Inserisci il tuo indirizzo e-mail e ti invieremo un codice di sicurezza per accedere."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1321973278 = messageFormatterFn((function(  ) {
  return function(d) { return "Invia e-mail"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1570366826 = messageFormatterFn((function(  ) {
  return function(d) { return "Contattaci"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a2014734021 = messageFormatterFn((function(  ) {
  return function(d) { return "Elimina account"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1209684410 = messageFormatterFn((function(  ) {
  return function(d) { return "Chiudi"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b2115714082 = messageFormatterFn((function(  ) {
  return function(d) { return "Solo un momento, stiamo controllando il tuo account..."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1134559137 = messageFormatterFn((function(  ) {
  return function(d) { return "Elimina account"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1310804219 = messageFormatterFn((function(  ) {
  return function(d) { return "Chiudi"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b535221089 = messageFormatterFn((function(  ) {
  return function(d) { return "Non puoi eliminare l’account fino al completamento di un viaggio."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1516210304 = messageFormatterFn((function(  ) {
  return function(d) { return "Potresti aver bisogno del tuo account per accedere alla prenotazione e ricevere assistenza dal supporto clienti in caso di modifiche last minute."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a197111315 = messageFormatterFn((function(  ) {
  return function(d) { return "Prima devi eliminare il tuo account proprietario Vrbo"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1738317380 = messageFormatterFn((function(  ) {
  return function(d) { return "Visita il nostro portale di aiuto sul sito o sull’app per contattare direttamente l’assistenza clienti e avviare la procedura."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1772798860 = messageFormatterFn((function(  ) {
  return function(d) { return "Riprova al termine del tuo viaggio."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1424001391 = messageFormatterFn((function(  ) {
  return function(d) { return "Perché vuoi eliminare il tuo account?"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b545297698 = messageFormatterFn((function(  ) {
  return function(d) { return "Ricevo troppe e-mail o notifiche"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1112759692 = messageFormatterFn((function(  ) {
  return function(d) { return "Ho un altro account " + d["0"]; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a2079127471 = messageFormatterFn((function(  ) {
  return function(d) { return "Il mio viaggio è terminato e non mi serve più questo account"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b280081099 = messageFormatterFn((function(  ) {
  return function(d) { return "La mia esperienza di prenotazione con " + d["0"] + " è stata negativa"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1362995466 = messageFormatterFn((function(  ) {
  return function(d) { return "Altro"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1364074893 = messageFormatterFn((function(  ) {
  return function(d) { return "Salta"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1319718458 = messageFormatterFn((function(  ) {
  return function(d) { return "Invia"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a439975242 = messageFormatterFn((function(  ) {
  return function(d) { return "Ci dispiace vederti andar via. Ecco alcune informazioni di cui dovresti tenere conto:"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a5352067 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderai definitivamente " + d["0"] + " punti Expedia Rewards (per un valore pari a " + d["1"] + "), " + d["2"] + " in crediti, eventuali coupon e prodotti di viaggio salvati, e preferenze relative al tuo account."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b2008494386 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderai definitivamente " + d["0"] + " punti Expedia Rewards (per un valore pari a " + d["1"] + "), eventuali coupon e prodotti di viaggio salvati, e preferenze relative al tuo account."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a683736400 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderai definitivamente le tue Bacheche Viaggi, i crediti e le preferenze."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b843051514 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels.com Rewards: perderai " + d["0"] + " notti bonus (per un valore pari a " + d["1"] + ") e " + d["2"] + " timbri del valore medio di " + d["3"] + "."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a717191447 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderai definitivamente crediti, eventuali coupon e prodotti di viaggio salvati, e preferenze relative al tuo account."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b887316289 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderai definitivamente " + d["0"] + " CheapCash (per un valore pari a " + d["1"] + "), " + d["2"] + " in crediti, eventuali coupon e prodotti di viaggio salvati, e preferenze relative al tuo account."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a2110446354 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderai definitivamente " + d["0"] + " CheapCash (per un valore pari a " + d["1"] + "), eventuali coupon e prodotti di viaggio salvati, e preferenze relative al tuo account."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a622844407 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderai definitivamente " + d["0"] + " Orbucks (per un valore pari a " + d["1"] + "), " + d["2"] + " in crediti, eventuali coupon e prodotti di viaggio salvati, e preferenze relative al tuo account."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a278277850 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderai definitivamente " + d["0"] + " Orbucks (per un valore pari a " + d["1"] + "), eventuali coupon e prodotti di viaggio salvati, e preferenze relative al tuo account."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a330560707 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderai definitivamente " + d["0"] + " MrJet Rewards (per un valore pari a " + d["1"] + "), " + d["2"] + " in crediti, eventuali coupon e prodotti di viaggio salvati, e preferenze relative al tuo account."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a702389390 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderai definitivamente " + d["0"] + " MrJet Rewards (per un valore pari a " + d["1"] + "), eventuali coupon e prodotti di viaggio salvati, e preferenze relative al tuo account."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a14791007 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderai definitivamente " + d["0"] + " BONUS+ (per un valore pari a " + d["1"] + "), " + d["2"] + " in crediti, eventuali coupon e prodotti di viaggio salvati, e preferenze relative al tuo account."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1413686898 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderai definitivamente " + d["0"] + " BONUS+ (per un valore pari a " + d["1"] + "), eventuali coupon e prodotti di viaggio salvati, e preferenze relative al tuo account."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a2062913513 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderai definitivamente eventuali coupon e prodotti di viaggio salvati, e preferenze relative al tuo account."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a104155326 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderai definitivamente " + d["0"] + " in crediti, eventuali coupon e prodotti di viaggio salvati, e preferenze relative al tuo account."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a796438200 = messageFormatterFn((function(  ) {
  return function(d) { return "Potremmo conservare alcune informazioni, come il registro delle tue transazioni, per adempiere ai nostri obblighi giuridici o se dovessimo definire un’azione legale, avviarla o difenderci in relazione a essa. Queste informazioni verranno conservate in maniera sicura e saranno cancellate, rese anonime o offuscate in modo permanente quando non saranno più necessarie."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1599890740 = messageFormatterFn((function(  ) {
  return function(d) { return "Elimina definitivamente l’account"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a2074451196 = messageFormatterFn((function(  ) {
  return function(d) { return "Non eliminare l’account"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1434625906 = messageFormatterFn((function(  ) {
  return function(d) { return "Speriamo di rivederti presto."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1721141651 = messageFormatterFn((function(  ) {
  return function(d) { return "Potrebbero volerci alcune settimane per elaborare la richiesta di eliminazione del tuo account. Nel frattempo, potresti continuare a ricevere comunicazioni."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1747973523 = messageFormatterFn((function(  ) {
  return function(d) { return "Riprova"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b2033165740 = messageFormatterFn((function(  ) {
  return function(d) { return "Si è verificato un errore di sistema. Richiedi nuovamente l’eliminazione del tuo account o riprova tra qualche minuto."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1366269596 = messageFormatterFn((function(  ) {
  return function(d) { return "Chiudi"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a97058933 = messageFormatterFn((function(  ) {
  return function(d) { return "Qual è il nome indicato sul tuo documento?"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b22736325 = messageFormatterFn((function(  ) {
  return function(d) { return "Nome e cognome devono essere quelli indicati sul tuo documento di viaggio (ad es. passaporto o patente). Salveremo le informazioni per quando prenoti."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1048946135 = messageFormatterFn((function(  ) {
  return function(d) { return "Voglio ricevere e-mail da " + d["0"] + " con offerte, promozioni e altre informazioni."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b56044826 = messageFormatterFn((function(  ) {
  return function(d) { return "Voglio ricevere e-mail da " + d["0"] + " con offerte, promozioni e altre informazioni. Puoi annullare l’iscrizione alle comunicazioni commerciali quando vuoi."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b893661535 = messageFormatterFn((function(  ) {
  return function(d) { return "Dettagli dell’account"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1982324297 = messageFormatterFn((function(  ) {
  return function(d) { return "Ricevi e-mail su offerte, promozioni e altre informazioni da " + d["0"] + ". Puoi disattivare il servizio quando vuoi."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a882937427 = messageFormatterFn((function(  ) {
  return function(d) { return "Ricevi tutti gli aggiornamenti"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1400129613 = messageFormatterFn((function(  ) {
  return function(d) { return "Consenso marketing"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1310796738 = messageFormatterFn((function(  ) {
  return function(d) { return "Expedia Rewards"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1398214368 = messageFormatterFn((function(  ) {
  return function(d) { return "CheapCash"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b859065128 = messageFormatterFn((function(  ) {
  return function(d) { return "Orbitz Rewards"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1828870144 = messageFormatterFn((function(  ) {
  return function(d) { return "BONUS+"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a698399170 = messageFormatterFn((function(  ) {
  return function(d) { return "MrJet"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1970006247 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels.com Rewards"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1722013765 = messageFormatterFn((function(  ) {
  return function(d) { return "One Key"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1857736562 = messageFormatterFn((function(  ) {
  return function(d) { return "Devi attendere fino al completamento del viaggio"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b757466210 = messageFormatterFn((function(  ) {
  return function(d) { return "Devi attendere fino al completamento dei viaggi"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a558666332 = messageFormatterFn((function(  ) {
  return function(d) { return "Se hai bisogno, puoi accedere ai dettagli della prenotazione e richiedere assistenza dal tuo account. Riprova al termine del tuo viaggio."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b95329400 = messageFormatterFn((function(  ) {
  return function(d) { return "Se hai bisogno, puoi accedere ai dettagli della prenotazione e richiedere assistenza dal tuo account. Riprova al termine dei tuoi viaggi."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1999773441 = messageFormatterFn((function(  ) {
  return function(d) { return "Al momento non è possibile eliminare questo account"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a2096089323 = messageFormatterFn((function(  ) {
  return function(d) { return "Questo account è utilizzato anche da un host di Vrbo. Per poterlo eliminare, devi accedere al sito o all’app per proprietari di Vrbo e rimuovere gli annunci attivi."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a97147876 = messageFormatterFn((function(  ) {
  return function(d) { return "Dicci perché vuoi eliminare il tuo account."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b827207289 = messageFormatterFn((function(  ) {
  return function(d) { return "Ho un account associato a un altro indirizzo e-mail"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1216259976 = messageFormatterFn((function(  ) {
  return function(d) { return "Ho avuto un’esperienza negativa con una prenotazione"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b651643939 = messageFormatterFn((function(  ) {
  return function(d) { return "Ci dispiace vederti andare via. Ti ricordiamo che l’eliminazione dell’account non può essere annullata e avrà ripercussioni sui tuoi dati presenti su Expedia, Hotels.com e Vrbo. Ecco alcune informazioni di cui dovresti tenere conto:"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a54889192 = messageFormatterFn((function(  ) {
  return function(d) { return "Ci dispiace vederti andare via. Ti ricordiamo che l’eliminazione dell’account non può essere annullata e avrà ripercussioni sui tuoi dati presenti su Expedia, Wotif, Hotels.com e Vrbo. Ecco alcune informazioni di cui dovresti tenere conto:"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1523834431 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderai definitivamente la cronologia dell’account, le preferenze e gli elementi salvati su Expedia, Hotels.com e Vrbo."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1586226122 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderai definitivamente la cronologia dell’account, le preferenze e gli elementi salvati su Expedia, Wotif, Hotels.com e Vrbo."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a283683123 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderai definitivamente il tuo OneKeyCash, anche quello in sospeso, oltre al livello di iscrizione a One Key e ai relativi vantaggi."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b318353239 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderai definitivamente il tuo OneKeyCash in sospeso, oltre al livello di iscrizione a One Key e ai relativi vantaggi."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a827054946 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderai definitivamente " + d["0"] + " in OneKeyCash e il OneKeyCash in sospeso, oltre al livello di iscrizione a One Key e ai relativi vantaggi."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a464534452 = messageFormatterFn((function(  ) {
  return function(d) { return "I titolari della carta di credito Hotels.com Rewards non otterranno più vantaggi legati all’utilizzo della carta."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1943532689 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderai definitivamente tutti i punti Expedia Rewards, sia quelli confermati sia quelli in sospeso, i timbri e le notti bonus Hotels.com Rewards e il livello di iscrizione al programma fedeltà."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a826863879 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderai definitivamente tutti i punti Expedia Rewards in sospeso, i timbri e le notti bonus Hotels.com Rewards e il livello di iscrizione al programma fedeltà."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1626994445 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderai definitivamente tutti i coupon e i crediti Expedia, Hotels.com e Vrbo."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b687625704 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderai definitivamente tutti i coupon e i crediti Expedia, Wotif, Hotels.com e Vrbo."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1942772378 = messageFormatterFn((function(  ) {
  return function(d) { return "Potrebbero volerci alcune settimane per elaborare la richiesta di eliminazione del tuo account Expedia, Hotels.com e Vrbo. Nel frattempo, potresti continuare a ricevere comunicazioni."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b741510735 = messageFormatterFn((function(  ) {
  return function(d) { return "Potrebbero volerci alcune settimane per elaborare la richiesta di eliminazione del tuo account Expedia, Wotif, Hotels.com e Vrbo. Nel frattempo, potresti continuare a ricevere comunicazioni."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b73207333 = messageFormatterFn((function(  ) {
  return function(d) { return "Se elimini il tuo account, la tua One Key Card verrà chiusa e non guadagnerai più OneKeyCash sui tuoi acquisti. Wells Fargo ti contatterà per confermare la chiusura della tua carta."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b2113762513 = messageFormatterFn((function(  ) {
  return function(d) { return "Se elimini il tuo account, la tua One Key Card verrà chiusa e non guadagnerai più OneKeyCash sui tuoi acquisti. Wells Fargo ti contatterà per confermare la chiusura della tua carta."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1801719972 = messageFormatterFn((function(  ) {
  return function(d) { return "Accedi al tuo account o creane uno per guadagnare OneKeyCash grazie a questo viaggio."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b845758466 = messageFormatterFn((function(  ) {
  return function(d) { return "Accedi al tuo account o creane uno per ottenere vantaggi grazie a questo soggiorno."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1034805723 = messageFormatterFn((function(  ) {
  return function(d) { return "Prenota senza account"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b311011309 = messageFormatterFn((function(  ) {
  return function(d) { return "Accesso account " + d["0"] + ": aggiungi il tuo numero"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1854505149 = messageFormatterFn((function(  ) {
  return function(d) { return "Si è verificato un problema"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.b1224467863 = messageFormatterFn((function(  ) {
  return function(d) { return "Riprova ad accedere al tuo account."; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a1009560928 = messageFormatterFn((function(  ) {
  return function(d) { return "OK"; }
})(), Globalize("it-IT").pluralGenerator({}));
Globalize.a474837848 = dateToPartsFormatterFn({"2":Globalize("it-IT").numberFormatter({"raw":"00"}),"4":Globalize("it-IT").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy-MM-dd","timeSeparator":":"});
Globalize.b639708520 = dateToPartsFormatterFn({"2":Globalize("it-IT").numberFormatter({"raw":"00"}),"4":Globalize("it-IT").numberFormatter({"raw":"0000"})}, {"pattern":"dd/MM/yyyy","timeSeparator":":"});
Globalize.b1767275285 = dateToPartsFormatterFn({"1":Globalize("it-IT").numberFormatter({"raw":"0"}),"4":Globalize("it-IT").numberFormatter({"raw":"0000"})}, {"pattern":"d/M/yyyy","timeSeparator":":"});
Globalize.a1405238053 = dateToPartsFormatterFn({"1":Globalize("it-IT").numberFormatter({"raw":"0"}),"4":Globalize("it-IT").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/M/d","timeSeparator":":"});
Globalize.b585567496 = dateToPartsFormatterFn({"2":Globalize("it-IT").numberFormatter({"raw":"00"}),"4":Globalize("it-IT").numberFormatter({"raw":"0000"})}, {"pattern":"dd.MM.yyyy","timeSeparator":":"});
Globalize.a981395181 = dateToPartsFormatterFn({"1":Globalize("it-IT").numberFormatter({"raw":"0"}),"4":Globalize("it-IT").numberFormatter({"raw":"0000"})}, {"pattern":"d.M.yyyy","timeSeparator":":"});
Globalize.a1212154520 = dateToPartsFormatterFn({"2":Globalize("it-IT").numberFormatter({"raw":"00"}),"4":Globalize("it-IT").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/MM/dd","timeSeparator":":"});
Globalize.b531426472 = dateToPartsFormatterFn({"2":Globalize("it-IT").numberFormatter({"raw":"00"}),"4":Globalize("it-IT").numberFormatter({"raw":"0000"})}, {"pattern":"dd-MM-yyyy","timeSeparator":":"});
Globalize.b1932200 = dateToPartsFormatterFn({"2":Globalize("it-IT").numberFormatter({"raw":"00"}),"4":Globalize("it-IT").numberFormatter({"raw":"0000"})}, {"pattern":"MM/dd/yyyy","timeSeparator":":"});
Globalize.b2008846677 = dateToPartsFormatterFn({"1":Globalize("it-IT").numberFormatter({"raw":"0"}),"4":Globalize("it-IT").numberFormatter({"raw":"0000"})}, {"pattern":"M/d/yyyy","timeSeparator":":"});
Globalize.b1303987464 = dateToPartsFormatterFn({"2":Globalize("it-IT").numberFormatter({"raw":"00"}),"4":Globalize("it-IT").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy.MM.dd","timeSeparator":":"});
Globalize.b896662009 = dateToPartsFormatterFn({}, {"pattern":"EEEEE","timeSeparator":":","days":{"E":{"5":{"sun":"D","mon":"L","tue":"M","wed":"M","thu":"G","fri":"V","sat":"S"}}}});
Globalize.a2049254552 = dateToPartsFormatterFn({}, {"pattern":"EEEE","timeSeparator":":","days":{"E":{"4":{"sun":"domenica","mon":"lunedì","tue":"martedì","wed":"mercoledì","thu":"giovedì","fri":"venerdì","sat":"sabato"}}}});
Globalize.a796009112 = dateToPartsFormatterFn({}, {"pattern":"MMMM","timeSeparator":":","months":{"M":{"4":{"1":"gennaio","2":"febbraio","3":"marzo","4":"aprile","5":"maggio","6":"giugno","7":"luglio","8":"agosto","9":"settembre","10":"ottobre","11":"novembre","12":"dicembre"}}}});
Globalize.b465573560 = dateToPartsFormatterFn({"1":Globalize("it-IT").numberFormatter({"raw":"0"})}, {"pattern":"d","timeSeparator":":"});
Globalize.b2125076469 = dateToPartsFormatterFn({"1":Globalize("it-IT").numberFormatter({"raw":"0"}),"2":Globalize("it-IT").numberFormatter({"raw":"00"})}, {"pattern":"M/d/yy","timeSeparator":":"});
Globalize.a975670998 = dateToPartsFormatterFn({"1":Globalize("it-IT").numberFormatter({"raw":"0"})}, {"pattern":"d MMM","timeSeparator":":","months":{"M":{"3":{"1":"gen","2":"feb","3":"mar","4":"apr","5":"mag","6":"giu","7":"lug","8":"ago","9":"set","10":"ott","11":"nov","12":"dic"}}}});
Globalize.a161668723 = dateToPartsFormatterFn({"1":Globalize("it-IT").numberFormatter({"raw":"0"})}, {"pattern":"d MMMM","timeSeparator":":","months":{"M":{"4":{"1":"gennaio","2":"febbraio","3":"marzo","4":"aprile","5":"maggio","6":"giugno","7":"luglio","8":"agosto","9":"settembre","10":"ottobre","11":"novembre","12":"dicembre"}}}});
Globalize.b1521183070 = dateToPartsFormatterFn({"1":Globalize("it-IT").numberFormatter({"raw":"0"})}, {"pattern":"d MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"gennaio","2":"febbraio","3":"marzo","4":"aprile","5":"maggio","6":"giugno","7":"luglio","8":"agosto","9":"settembre","10":"ottobre","11":"novembre","12":"dicembre"}}}});
Globalize.b464773058 = dateToPartsFormatterFn({"1":Globalize("it-IT").numberFormatter({"raw":"0"})}, {"pattern":"MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"gennaio","2":"febbraio","3":"marzo","4":"aprile","5":"maggio","6":"giugno","7":"luglio","8":"agosto","9":"settembre","10":"ottobre","11":"novembre","12":"dicembre"}}}});
Globalize.b464087865 = dateToPartsFormatterFn({"1":Globalize("it-IT").numberFormatter({"raw":"0"})}, {"pattern":"d MMM y","timeSeparator":":","months":{"M":{"3":{"1":"gen","2":"feb","3":"mar","4":"apr","5":"mag","6":"giu","7":"lug","8":"ago","9":"set","10":"ott","11":"nov","12":"dic"}}}});
Globalize.b235254762 = dateToPartsFormatterFn({"1":Globalize("it-IT").numberFormatter({"raw":"0"})}, {"pattern":"EEEE d MMM","timeSeparator":":","days":{"E":{"4":{"sun":"domenica","mon":"lunedì","tue":"martedì","wed":"mercoledì","thu":"giovedì","fri":"venerdì","sat":"sabato"}}},"months":{"M":{"3":{"1":"gen","2":"feb","3":"mar","4":"apr","5":"mag","6":"giu","7":"lug","8":"ago","9":"set","10":"ott","11":"nov","12":"dic"}}}});
Globalize.a154280555 = dateToPartsFormatterFn({"1":Globalize("it-IT").numberFormatter({"raw":"0"})}, {"pattern":"E d MMM","timeSeparator":":","days":{"E":{"1":{"sun":"dom","mon":"lun","tue":"mar","wed":"mer","thu":"gio","fri":"ven","sat":"sab"}}},"months":{"M":{"3":{"1":"gen","2":"feb","3":"mar","4":"apr","5":"mag","6":"giu","7":"lug","8":"ago","9":"set","10":"ott","11":"nov","12":"dic"}}}});
Globalize.a853551599 = dateFormatterFn(Globalize("it-IT").dateToPartsFormatter({"raw":"yyyy-MM-dd"}));
Globalize.b260994769 = dateFormatterFn(Globalize("it-IT").dateToPartsFormatter({"raw":"dd/MM/yyyy"}));
Globalize.a47641922 = dateFormatterFn(Globalize("it-IT").dateToPartsFormatter({"raw":"d/M/yyyy"}));
Globalize.b1074812036 = dateFormatterFn(Globalize("it-IT").dateToPartsFormatter({"raw":"yyyy/M/d"}));
Globalize.b206853745 = dateFormatterFn(Globalize("it-IT").dateToPartsFormatter({"raw":"dd.MM.yyyy"}));
Globalize.b1498654908 = dateFormatterFn(Globalize("it-IT").dateToPartsFormatter({"raw":"d.M.yyyy"}));
Globalize.a1590868271 = dateFormatterFn(Globalize("it-IT").dateToPartsFormatter({"raw":"yyyy/MM/dd"}));
Globalize.b152712721 = dateFormatterFn(Globalize("it-IT").dateToPartsFormatter({"raw":"dd-MM-yyyy"}));
Globalize.a376781551 = dateFormatterFn(Globalize("it-IT").dateToPartsFormatter({"raw":"MM/dd/yyyy"}));
Globalize.b193929470 = dateFormatterFn(Globalize("it-IT").dateToPartsFormatter({"raw":"M/d/yyyy"}));
Globalize.b925273713 = dateFormatterFn(Globalize("it-IT").dateToPartsFormatter({"raw":"yyyy.MM.dd"}));
Globalize.b1047835376 = dateFormatterFn(Globalize("it-IT").dateToPartsFormatter({"raw":"EEEEE"}));
Globalize.a1213093999 = dateFormatterFn(Globalize("it-IT").dateToPartsFormatter({"raw":"EEEE"}));
Globalize.b40151441 = dateFormatterFn(Globalize("it-IT").dateToPartsFormatter({"raw":"MMMM"}));
Globalize.a117710033 = dateFormatterFn(Globalize("it-IT").dateToPartsFormatter({"raw":"d"}));
Globalize.a1778483746 = dateFormatterFn(Globalize("it-IT").dateToPartsFormatter({"raw":"M/d/yy"}));
Globalize.a1403529567 = dateFormatterFn(Globalize("it-IT").dateToPartsFormatter({"skeleton":"MMMd"}));
Globalize.a540382474 = dateFormatterFn(Globalize("it-IT").dateToPartsFormatter({"skeleton":"MMMMd"}));
Globalize.a1629008619 = dateFormatterFn(Globalize("it-IT").dateToPartsFormatter({"skeleton":"yMMMMd"}));
Globalize.b86059307 = dateFormatterFn(Globalize("it-IT").dateToPartsFormatter({"skeleton":"yMMMM"}));
Globalize.b85374114 = dateFormatterFn(Globalize("it-IT").dateToPartsFormatter({"skeleton":"yMMMd"}));
Globalize.b852985313 = dateFormatterFn(Globalize("it-IT").dateToPartsFormatter({"skeleton":"MMMEEEEd"}));
Globalize.a532994306 = dateFormatterFn(Globalize("it-IT").dateToPartsFormatter({"skeleton":"MMMEd"}));
Globalize.b1827353954 = dateParserFn(Globalize("it-IT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy-MM-dd","digitsRe":/\d/});
Globalize.a1353066974 = dateParserFn(Globalize("it-IT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd/MM/yyyy","digitsRe":/\d/});
Globalize.b741739087 = dateParserFn(Globalize("it-IT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/M/yyyy","digitsRe":/\d/});
Globalize.b1864193045 = dateParserFn(Globalize("it-IT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/M/d","digitsRe":/\d/});
Globalize.a1407207998 = dateParserFn(Globalize("it-IT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd.MM.yyyy","digitsRe":/\d/});
Globalize.a2006931379 = dateParserFn(Globalize("it-IT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.M.yyyy","digitsRe":/\d/});
Globalize.b1090037282 = dateParserFn(Globalize("it-IT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/MM/dd","digitsRe":/\d/});
Globalize.a1461349022 = dateParserFn(Globalize("it-IT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd-MM-yyyy","digitsRe":/\d/});
Globalize.a1990843294 = dateParserFn(Globalize("it-IT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MM/dd/yyyy","digitsRe":/\d/});
Globalize.b983310479 = dateParserFn(Globalize("it-IT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yyyy","digitsRe":/\d/});
Globalize.a688788030 = dateParserFn(Globalize("it-IT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy.MM.dd","digitsRe":/\d/});
Globalize.a758299393 = dateParserFn(Globalize("it-IT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEEE","digitsRe":/\d/,"gregorian/days/format/narrow":[["sun",/^D/],["mon",/^L/],["tue",/^M/],["wed",/^M/],["thu",/^G/],["fri",/^V/],["sat",/^S/]]});
Globalize.a301525086 = dateParserFn(Globalize("it-IT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE","digitsRe":/\d/,"gregorian/days/format/wide":[["wed",/^mercoledì/],["sun",/^domenica/],["tue",/^martedì/],["thu",/^giovedì/],["fri",/^venerdì/],["mon",/^lunedì/],["sat",/^sabato/]]});
Globalize.b951720354 = dateParserFn(Globalize("it-IT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^settembre/],["2",/^febbraio/],["11",/^novembre/],["12",/^dicembre/],["1",/^gennaio/],["10",/^ottobre/],["4",/^aprile/],["5",/^maggio/],["6",/^giugno/],["7",/^luglio/],["8",/^agosto/],["3",/^marzo/]]});
Globalize.b1440076990 = dateParserFn(Globalize("it-IT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d","digitsRe":/\d/});
Globalize.a1934086737 = dateParserFn(Globalize("it-IT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yy","digitsRe":/\d/});
Globalize.b1592445232 = dateParserFn(Globalize("it-IT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMM","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^gen/],["2",/^feb/],["3",/^mar/],["4",/^apr/],["5",/^mag/],["6",/^giu/],["7",/^lug/],["8",/^ago/],["9",/^set/],["10",/^ott/],["11",/^nov/],["12",/^dic/]]});
Globalize.b2140523079 = dateParserFn(Globalize("it-IT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^settembre/],["2",/^febbraio/],["11",/^novembre/],["12",/^dicembre/],["1",/^gennaio/],["10",/^ottobre/],["4",/^aprile/],["5",/^maggio/],["6",/^giugno/],["7",/^luglio/],["8",/^agosto/],["3",/^marzo/]]});
Globalize.a125315100 = dateParserFn(Globalize("it-IT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^settembre/],["2",/^febbraio/],["11",/^novembre/],["12",/^dicembre/],["1",/^gennaio/],["10",/^ottobre/],["4",/^aprile/],["5",/^maggio/],["6",/^giugno/],["7",/^luglio/],["8",/^agosto/],["3",/^marzo/]]});
Globalize.a1528002436 = dateParserFn(Globalize("it-IT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^settembre/],["2",/^febbraio/],["11",/^novembre/],["12",/^dicembre/],["1",/^gennaio/],["10",/^ottobre/],["4",/^aprile/],["5",/^maggio/],["6",/^giugno/],["7",/^luglio/],["8",/^agosto/],["3",/^marzo/]]});
Globalize.a1528687629 = dateParserFn(Globalize("it-IT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMM y","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^gen/],["2",/^feb/],["3",/^mar/],["4",/^apr/],["5",/^mag/],["6",/^giu/],["7",/^lug/],["8",/^ago/],["9",/^set/],["10",/^ott/],["11",/^nov/],["12",/^dic/]]});
Globalize.a1501521680 = dateParserFn(Globalize("it-IT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE d MMM","digitsRe":/\d/,"gregorian/days/format/wide":[["wed",/^mercoledì/],["sun",/^domenica/],["tue",/^martedì/],["thu",/^giovedì/],["fri",/^venerdì/],["mon",/^lunedì/],["sat",/^sabato/]],"gregorian/months/format/abbreviated":[["1",/^gen/],["2",/^feb/],["3",/^mar/],["4",/^apr/],["5",/^mag/],["6",/^giu/],["7",/^lug/],["8",/^ago/],["9",/^set/],["10",/^ott/],["11",/^nov/],["12",/^dic/]]});
Globalize.a2147056049 = dateParserFn(Globalize("it-IT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"E d MMM","digitsRe":/\d/,"gregorian/days/format/abbreviated":[["sun",/^dom/],["mon",/^lun/],["tue",/^mar/],["wed",/^mer/],["thu",/^gio/],["fri",/^ven/],["sat",/^sab/]],"gregorian/months/format/abbreviated":[["1",/^gen/],["2",/^feb/],["3",/^mar/],["4",/^apr/],["5",/^mag/],["6",/^giu/],["7",/^lug/],["8",/^ago/],["9",/^set/],["10",/^ott/],["11",/^nov/],["12",/^dic/]]});
module.exports = Globalize;
